// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from wallet-rbac/capabilities.js
// by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet-app/wallet-rbac/capabilities.js
//   2. Run ./scripts/sync_wallet_app.sh
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// wallet-rbac/capabilities.js
//
// Customer-side capability enum — mirror of the C++ `Capability` enum that
// will live in cpp/src/enums/rbac/capability.hpp.

export const ROLES = {
  VIEWER: 'viewer',
  SIGNER: 'signer',
  TREASURER: 'treasurer',
  ADMIN: 'admin',
};

export const CAPABILITIES = {
  VIEW_QUOTES: 'VIEW_QUOTES',
  VIEW_HISTORY: 'VIEW_HISTORY',
  VIEW_RECEIPTS: 'VIEW_RECEIPTS',

  BRIDGE_SWAP: 'BRIDGE_SWAP',
  AUTO_MINT: 'AUTO_MINT',
  CARD_BUY: 'CARD_BUY',
  KFX_SWAP: 'KFX_SWAP',
  APPROVE_TOKEN: 'APPROVE_TOKEN',

  CONFIGURE_LIMITS: 'CONFIGURE_LIMITS',
  EXPORT_REPORTS: 'EXPORT_REPORTS',
};

const ROLE_CAPABILITIES = {
  [ROLES.VIEWER]: new Set([
    CAPABILITIES.VIEW_QUOTES,
    CAPABILITIES.VIEW_HISTORY,
    CAPABILITIES.VIEW_RECEIPTS,
  ]),
  [ROLES.SIGNER]: new Set([
    CAPABILITIES.VIEW_QUOTES,
    CAPABILITIES.VIEW_HISTORY,
    CAPABILITIES.VIEW_RECEIPTS,
    CAPABILITIES.BRIDGE_SWAP,
    CAPABILITIES.AUTO_MINT,
    CAPABILITIES.CARD_BUY,
    CAPABILITIES.KFX_SWAP,
    CAPABILITIES.APPROVE_TOKEN,
  ]),
  [ROLES.TREASURER]: new Set([
    CAPABILITIES.VIEW_QUOTES,
    CAPABILITIES.VIEW_HISTORY,
    CAPABILITIES.VIEW_RECEIPTS,
    CAPABILITIES.BRIDGE_SWAP,
    CAPABILITIES.AUTO_MINT,
    CAPABILITIES.CARD_BUY,
    CAPABILITIES.KFX_SWAP,
    CAPABILITIES.APPROVE_TOKEN,
    CAPABILITIES.CONFIGURE_LIMITS,
    CAPABILITIES.EXPORT_REPORTS,
  ]),
  [ROLES.ADMIN]: new Set([
    CAPABILITIES.VIEW_QUOTES,
    CAPABILITIES.VIEW_HISTORY,
    CAPABILITIES.VIEW_RECEIPTS,
    CAPABILITIES.BRIDGE_SWAP,
    CAPABILITIES.AUTO_MINT,
    CAPABILITIES.CARD_BUY,
    CAPABILITIES.KFX_SWAP,
    CAPABILITIES.APPROVE_TOKEN,
    CAPABILITIES.CONFIGURE_LIMITS,
    CAPABILITIES.EXPORT_REPORTS,
  ]),
};

export function roleHasCapability(role, capability) {
  if (!role || !capability) return false;
  const set = ROLE_CAPABILITIES[role];
  if (!set) return false;
  return set.has(capability);
}

export function capabilitiesFor(role) {
  const set = ROLE_CAPABILITIES[role];
  if (!set) return [];
  return Array.from(set);
}
